//import React, { useState } from 'react';
//import React, { useState, useRef } from 'react';
import React, { useState, useRef, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Banner from '../../components/banner/SolutionBanner';
import Footer from '../../components/footer/Footer';
import Create from '../../components/create/Create2';
import heroImg from '../../assets/solutions/AR-Business-Card/hero-image.jpg';
//import ctaImg from '../../assets/solutions/AR-Business-Card/cta-background.jpg';
import comparisonImg from '../../assets/solutions/AR-Business-Card/comparison-visual.png';
import phoneMockupImg from '../../assets/solutions/AR-Business-Card/phone-mockup.png';
import dashboardImg from '../../assets/solutions/AR-Business-Card/dashboard-screenshot.png';
import usecaseRealEstate from '../../assets/solutions/AR-Business-Card/usecase-realestate.jpg';
import usecaseCorporate from '../../assets/solutions/AR-Business-Card/usecase-corporate.jpg';
import usecaseEvents from '../../assets/solutions/AR-Business-Card/usecase-events.jpg';
import usecaseLuxury from '../../assets/solutions/AR-Business-Card/usecase-luxury.jpg';
import ContactModal from '../contactModal.jsx';
import { getContactFormHandlerUrl } from '../../utils/contactFormApi';

// ── Inline SVG Icons ──────────────────────────────────────────────────────────
const QrCodeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect width="5" height="5" x="3" y="3" rx="1"/><rect width="5" height="5" x="16" y="3" rx="1"/>
        <rect width="5" height="5" x="3" y="16" rx="1"/><path d="M21 16h-3a2 2 0 0 0-2 2v3"/>
        <path d="M21 21v.01"/><path d="M12 7v3a2 2 0 0 1-2 2H7"/>
        <path d="M3 12h.01"/><path d="M12 3h.01"/><path d="M12 16v.01"/>
        <path d="M16 12h1"/><path d="M21 12v.01"/><path d="M12 21v-1"/>
    </svg>
);
const GlobeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/>
        <path d="M2 12h20"/>
    </svg>
);
const UserIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
    </svg>
);
const MessageIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/>
    </svg>
);
const PointerIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 4.1 12 6"/><path d="m5.1 8-2.9-.8"/><path d="m6 12-1.9 2"/>
        <path d="M7.2 2.2 8 5.1"/>
        <path d="M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z"/>
    </svg>
);
const BotIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 8V4H8"/><rect width="16" height="12" x="4" y="8" rx="2"/>
        <path d="M2 14h2"/><path d="M20 14h2"/><path d="M15 13v2"/><path d="M9 13v2"/>
    </svg>
);
const LanguagesIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="m5 8 6 6"/><path d="m4 14 6-6 2-3"/><path d="M2 5h12"/><path d="M7 2h1"/>
        <path d="m22 22-5-10-5 10"/><path d="M14 18h6"/>
    </svg>
);
const PresentationIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 3h20"/><path d="M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3"/><path d="m7 21 5-5 5 5"/>
    </svg>
);
const UserCheckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
        <polyline points="16 11 18 13 22 9"/>
    </svg>
);
const ContactRoundIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 2v2"/><path d="M17.915 22a6 6 0 0 0-12 0"/><path d="M8 2v2"/>
        <circle cx="12" cy="12" r="4"/><rect x="3" y="4" width="18" height="18" rx="2"/>
    </svg>
);
const CheckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0bcbec" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6 9 17l-5-5"/>
    </svg>
);
const XIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.25)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
    </svg>
);
const ChevronDownIcon = ({ open }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.25s ease', flexShrink: 0 }}>
        <path d="m6 9 6 6 6-6"/>
    </svg>
);

// ── Shared style tokens ───────────────────────────────────────────────────────
const S = {
    section: {
        padding: '96px 0',
    },
    heading: {
        fontSize: 'clamp(28px, 4vw, 40px)',
        fontWeight: 700,
        color: '#fff',
        marginBottom: '16px',
        lineHeight: 1.2,
    },
    accent: {
        color: '#0bcbec',
    },
    subtext: {
        fontSize: '16px',
        color: 'rgba(255,255,255,0.55)',
        lineHeight: 1.7,
        maxWidth: '680px',
        margin: '0 auto',
    },
    card: {
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: '16px',
    },
    glowCard: {
        background: 'rgba(11,203,236,0.05)',
        border: '1px solid rgba(11,203,236,0.2)',
        borderRadius: '16px',
        boxShadow: '0 0 20px rgba(11,203,236,0.08)',
    },
    iconBox: {
        width: '56px',
        height: '56px',
        borderRadius: '14px',
        background: 'rgba(11,203,236,0.12)',
        border: '1px solid rgba(11,203,236,0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#0bcbec',
        marginBottom: '20px',
    },
};

function BusinessCard(props) {
    const [openFaq, setOpenFaq] = useState(null);
    const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isPortrait, setIsPortrait] = useState(window.innerWidth <= 767);
    const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
    const [downloadForm, setDownloadForm] = useState({ name: '', email: '' });
    const [downloadSubmitted, setDownloadSubmitted] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [downloadError, setDownloadError] = useState(false);
    const [downloadFormErrors, setDownloadFormErrors] = useState({});
    const [quoteForm, setQuoteForm] = useState({
        numCards: 1,
        industryType: 'sales',
        avatarType: 'standard',
        voiceType: 'standard',
        workflowType: 'no',
        workflowDesc: '',
        usageTier: 26.4,
        llmType: 0.4,
        clientName: '',
        clientCompany: '',
        clientEmail: '',
    });
    const [quoteResultVisible, setQuoteResultVisible] = useState(false);
    const [quoteTotal, setQuoteTotal] = useState({ usd: 0, aed: 0 });
    const [quoteModalTotal, setQuoteModalTotal] = useState({ usd: 0, aed: 0 });
    const [quoteSubmitLoading, setQuoteSubmitLoading] = useState(false);
    const [quoteEmailError, setQuoteEmailError] = useState('');

    useEffect(() => {
    const handleResize = () => setIsPortrait(window.innerWidth <= 767);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
}, []);

useEffect(() => {
    if (videoRef.current) {
        videoRef.current.poster = isPortrait
            ? '/videos/portrait-thumbnail.png'
            : '/videos/landscape-thumbnail.png';
    }
}, [isPortrait]);

useEffect(() => {
    const numCards = Number(quoteForm.numCards) || 0;
    const baseMonthly = Number(quoteForm.usageTier) || 0;
    const llmMarkup = Number(quoteForm.llmType) || 0;

    let upfrontPerCard = 1000;
    if (quoteForm.avatarType === 'custom') upfrontPerCard += 1600;
    if (quoteForm.voiceType === 'cloned') upfrontPerCard += 750;
    if (quoteForm.workflowType === 'yes') upfrontPerCard += 750;

    const totalUpfrontUSD = upfrontPerCard * numCards;
    const monthlyVoiceCost = baseMonthly * numCards;
    const monthlyLLMCost = monthlyVoiceCost * llmMarkup;
    const totalMonthlyUSD = monthlyVoiceCost + monthlyLLMCost;
    const totalAnnualUSD = totalMonthlyUSD * 12;

    const grandTotalUSD = totalUpfrontUSD + totalAnnualUSD;
    const grandTotalAED = grandTotalUSD * 3.67;

    setQuoteTotal({ usd: grandTotalUSD, aed: grandTotalAED });
}, [quoteForm.numCards, quoteForm.avatarType, quoteForm.voiceType, quoteForm.workflowType, quoteForm.usageTier, quoteForm.llmType]);

    // ── Data ─────────────────────────────────────────────────────────────────
const bannerData = {
    heading: 'AR Interactive AI Avatar Business Card',
    subheading: 'Your Business Card That Talks Back',
    desc: (
        <>
            <div style={{ marginBottom: '24px' }}>
                Turn a simple business card into an AI-powered AR experience that introduces you, answers questions, showcases your work, and captures leads instantly.
            </div>
            <div className="hero-button-group">
                {/* Added the onClick handler for smooth scrolling */}
                <button 
    className="btn-demo-primary"
    onClick={(e) => {
        // 1. Stop the button from doing anything else (like submitting or reloading)
        e.preventDefault(); 
        
        const element = document.getElementById('quote-form');
        if (element) {
            const topPosition = element.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: topPosition,
                behavior: 'smooth'
            });
        }
    }}
>
    Get your own Price
</button>
                <button 
    className="btn-demo-secondary"
    onClick={(e) => {
        e.preventDefault();
        setIsDemoModalOpen(true);
    }}
>
    Book a Demo
</button>
            </div>
        </>
    ),
    images: [heroImg],
};
    const contactData = {
        heading: 'Turn Every Business Card Into a <br> Conversation',
        desc: 'Join the future of networking. Let your business card do the talking.',
        btn: true,
        btnTitle: 'Book a Demo',
        link: '/contact',
        // img: ctaImg,
    };

    const howItWorksSteps = [
        { step: 'Step 1', title: 'Scan QR',        icon: <QrCodeIcon />,   desc: "Point your phone camera at the card's QR code" },
        { step: 'Step 2', title: 'Launch WebAR',   icon: <GlobeIcon />,    desc: 'Instant browser-based AR — no app needed' },
        { step: 'Step 3', title: 'Avatar Appears', icon: <UserIcon />,     desc: 'A lifelike AI avatar materializes before you' },
        { step: 'Step 4', title: 'Talk to AI',     icon: <MessageIcon />,  desc: 'Ask questions and get real-time intelligent responses' },
        { step: 'Step 5', title: 'Take Action',    icon: <PointerIcon />,  desc: 'Save contact, view portfolio, or book a meeting' },
    ];

    const features = [
        { icon: <BotIcon />,           title: 'AI Avatar Interaction',        desc: 'A realistic AI-powered avatar that represents you and engages in natural conversation with prospects.' },
        { icon: <LanguagesIcon />,     title: 'Multilingual Conversations',   desc: 'Break language barriers with support for 32+ languages, enabling global business connections.' },
        { icon: <PresentationIcon />,  title: 'Interactive Project Showcase', desc: 'Display your portfolio, case studies, and projects in an immersive AR environment.' },
        { icon: <UserCheckIcon />,     title: 'Lead Capture',                 desc: 'Automatically capture prospect information and sync to your CRM in real-time.' },
        { icon: <ContactRoundIcon />,  title: 'One-Tap Contact Save',         desc: 'Let prospects save your contact details to their phone with a single tap.' },
    ];

    const dashboardStats = [
        { label: 'Track scans & engagement' },
        { label: 'Capture & export leads' },
        { label: 'Monitor conversions' },
        { label: 'Update avatar knowledge' },
    ];

    const useCases = [
        { title: 'Corporate Sales & Reps', desc: 'Make every sales meeting memorable with an AI-powered introduction that captures leads on the spot.',   img: usecaseCorporate },
        { title: 'Real Estate',            desc: 'Let your AI avatar showcase properties, answer buyer questions, and schedule viewings automatically.',  img: usecaseRealEstate },
        { title: 'Events & Exhibitions',   desc: 'Stand out at trade shows with an interactive card that engages visitors long after the event ends.',    img: usecaseEvents },
        { title: 'Luxury Brands',          desc: 'Deliver a premium, unforgettable brand experience that matches the exclusivity of your products.',      img: usecaseLuxury },
    ];

    const comparisonRows = [
        { feature: 'Interactive Experience',    traditional: false, aiAr: true },
        { feature: 'AI-Powered Conversations',  traditional: false, aiAr: true },
        { feature: 'Lead Capture',              traditional: false, aiAr: true },
        { feature: 'Analytics & Tracking',      traditional: false, aiAr: true },
        { feature: 'Multilingual Support',      traditional: false, aiAr: true },
        { feature: 'One-Tap Contact Save',      traditional: false, aiAr: true },
        { feature: 'Portfolio Showcase',        traditional: false, aiAr: true },
        { feature: 'No App Required',           traditional: true,  aiAr: true },
        { feature: 'Updatable Content',         traditional: false, aiAr: true },
    ];

    const faqItems = [
        { question: 'Do users need to download an app?',              answer: "No! Our solution uses WebAR technology that runs directly in the browser. Users simply scan the QR code and the AR experience launches instantly — no app download required." },
        { question: 'Can I customize the AI avatar?',                 answer: "Absolutely. You can customize the avatar's appearance, voice, language, and the knowledge base it uses to answer questions. Make it truly represent your brand and personality." },
        { question: 'How does lead capture work?',                    answer: "When prospects interact with your AI avatar, they can share their contact details through a simple form. All leads are captured in real-time and synced to your dashboard, where you can export them to your CRM." },
        { question: 'Can I update the dashboard and avatar content?', answer: "Yes, you have full control through your dashboard. Update your avatar's knowledge base, modify responses, change visuals, and track performance — all in real-time without any technical skills." },
    ];
    const schemaMarkup = {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "Organization",
                "name": "AVR Labs",
                "url": "https://www.avrlabs.io",
                "logo": "https://www.avrlabs.io/cropped-Avr-logo-ai-1-192x192.png"
            },
            {
                "@type": "Product",
                "name": "AI AR Business Card",
                "description": "An AI-powered augmented reality business card that turns your card into an interactive avatar. It speaks, answers questions, showcases projects, and captures leads in real time without any app.",
                "brand": {
                    "@type": "Brand",
                    "name": "AVR Labs"
                },
                "category": "Augmented Reality Software",
                "image": "https://www.avrlabs.io/path-to-image.jpg",
                "url": "https://www.avrlabs.io/solutions/AI-AR-Business-Card",
                "offers": {
                    "@type": "Offer",
                    "url": "https://www.avrlabs.io/solutions/AI-AR-Business-Card",
                    "priceCurrency": "USD",
                    "price": "0",
                    "availability": "https://schema.org/InStock"
                }
            },
            {
                "@type": "SoftwareApplication",
                "name": "AI AR Business Card",
                "applicationCategory": "BusinessApplication",
                "operatingSystem": "Web",
                "description": "Web-based AR business card with AI avatar for engagement and lead generation.",
                "offers": {
                    "@type": "Offer",
                    "price": "0",
                    "priceCurrency": "USD"
                }
            },
            {
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What is an AI AR business card?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "An AI AR business card is a digital experience that uses augmented reality and AI to turn a simple card into an interactive avatar that can speak, answer questions, and capture leads in real time."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How does an AR business card work?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Users scan a QR code on your business card, which opens a WebAR experience in their browser. Your AI avatar appears, interacts with them, showcases your work, and guides them to take action like booking a meeting or sharing contact details."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Do users need to download an app?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "No. The AR experience runs directly in the mobile browser, so users can access it instantly without installing any app."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Can an AI business card capture leads?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes. The AI avatar can trigger lead forms, booking links, and contact actions during the conversation, automatically capturing and storing user information."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Who should use an AI AR business card?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "It is ideal for sales professionals, consultants, real estate agents, event exhibitors, and businesses that want to create memorable interactions and convert more leads."
                        }
                    }
                ]
            }
        ]
    };

    return (
        <div className='home-2 wrapper'>
            <Helmet>
                <title>AR Business Card with AI Avatar | Capture Leads Faster</title>
                <meta
                    name="description"
                    content="Upgrade your business card into an AI avatar that speaks, engages, and captures leads. Showcase projects, book meetings, and convert instantly with AR."
                />
                <script type="application/ld+json">
                    {JSON.stringify(schemaMarkup)}
                </script>
            </Helmet>

            {/* ── 1. Hero Banner ──────────────────────────────────────────────── */}
<div style={{ marginTop: '80px', marginBottom: '80px' }}>
    <style>{`
        /* 1. This targets ONLY the text container inside your Banner component */
        .banner-nudge-text .block-text {
            padding-top: 80px; /* Adjust this value to move the text lower or higher */
            padding-bottom: 40px; /* Adds some space below the text */
        }

        /* 2. Button styles */
        .hero-button-group {
            display: flex;
            gap: 16px;
            flex-wrap: wrap;
            justify-content: center; 
            margin-top: 24px; /* Optional: Adds a little breathing room above the buttons */
        }

        .btn-demo-primary {
            background-color: #00c3ff;
            color: #000000;
            border: 1px solid #00c3ff;
            border-radius: 8px;
            padding: 12px 28px;
            cursor: pointer;
            box-shadow: 0 4px 15px rgba(0, 195, 255, 0.15);
            transition: opacity 0.2s ease;
        }

        .btn-demo-primary:hover {
            opacity: 0.85;
        }

        .btn-demo-secondary {
            background-color: transparent;
            color: #00c3ff;
            border: 1px solid #00c3ff;
            border-radius: 8px;
            padding: 12px 28px;
            cursor: pointer;
            transition: background-color 0.2s ease;
        }

        .btn-demo-secondary:hover {
            background-color: rgba(0, 195, 255, 0.1);
        }
    `}</style>
    
    {/* Add the wrapper class here to apply the top padding */}
    <div className="banner-nudge-text">
        <Banner data={bannerData} />
    </div>
</div>

            {/* ── 2. Most Business Cards Are Forgotten ────────────────────────── */}
            <section style={S.section}>
                <div className="container">
                    {/* Heading */}
                    <div className="row">
                        <div className="col-12 text-center" style={{ marginBottom: '56px' }}>
                            <h2 style={S.heading}>
                                Most Business Cards Are <span style={S.accent}>Forgotten</span>
                            </h2>
                            <p style={S.subtext}>
                                Traditional business cards are passive. They sit in wallets, get lost in drawers, and fail to make lasting impressions. In a world where attention is everything, your first impression needs to be unforgettable.
                            </p>
                        </div>
                    </div>

                    {/* Comparison image */}
                    <div className="row justify-content-center" style={{ marginBottom: '32px' }}>
                        <div className="col-12 col-lg-10" style={{ display: 'flex', justifyContent: 'center' }}>
                            <style>
                                {`
                                    .responsive-comparison-img {
                                        width: 100%;
                                    }
                                    @media (min-width: 768px) {
                                        .responsive-comparison-img {
                                            width: 90%;
                                        }
                                    }
                                `}
                            </style>
                            <img
                                src={comparisonImg}
                                alt="Traditional vs AI AR business card comparison"
                                className="responsive-comparison-img"
                                style={{ display: 'block', margin: '0 auto' }}
                            />
                        </div>
                    </div>

                    {/* Two label cards */}
                    
                </div>
            </section>

            {/* ── 3. Meet the AI Interactive Business Card ─────────────────────── */}
            <section style={S.section}>
                <div className="container">
                    <div className="row align-items-center" style={{ gap: '0' }}>
                        {/* Left: text */}
                        <div className="col-12 col-lg-6" style={{ paddingRight: '40px', paddingLeft: '40px', marginBottom: '32px' }}>
                            <h2 style={{ ...S.heading, fontSize: 'clamp(28px, 3.5vw, 38px)', marginBottom: '20px' }}>
                                Meet the <span style={S.accent}>AI Interactive Business Card</span>
                            </h2>
                            <p style={{ fontSize: '16px', color: 'rgba(255,255,255,0.6)', lineHeight: 1.75, marginBottom: '28px' }}>
                                Simply scan the card to launch an immersive WebAR experience. A lifelike AI avatar appears, introduces you, answers questions in real-time, and lets prospects take action — all without downloading an app.
                            </p>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '14px' }}>
                                {[
                                    'No app download required',
                                    'Works on any smartphone',
                                    'AI-powered conversations in 32+ languages',
                                    'Instant lead capture & contact save',
                                ].map((point, i) => (
                                    <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', fontSize: '15px', color: 'rgba(255,255,255,0.75)' }}>
                                        <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#0bcbec', flexShrink: 0, display: 'inline-block' }} />
                                        {point}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {/* Right: phone mockup image */}
{/* Right: phone mockup image */}
<div className="col-12 col-lg-6" style={{ display: 'flex', justifyContent: 'center' }}>
    <div style={{ maxWidth: '420px', width: '100%' }}>
        <img
            src={phoneMockupImg}
            alt="Phone showing AR AI avatar interaction on business card"
            style={{ width: '55%', height: 'auto', display: 'block', margin: '0 auto' }}
        />
    </div>
</div>
                    </div>
                </div>
            </section>

{/* ── 4. See It In Action ──────────────────────────────────────────── */}
<section style={S.section} id="demo">
    <div className="container">
        <div className="row">
            <div className="col-12 text-center" style={{ marginBottom: '48px' }}>
                <h2 style={S.heading}>See It <span style={S.accent}>In Action</span></h2>
                <p style={S.subtext}>Watch how a simple card scan transforms into a full AI experience.</p>
            </div>
        </div>
        <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
                <div style={{
                    position: 'relative',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    border: '1px solid rgba(11,203,236,0.25)',
                    boxShadow: '0 0 48px rgba(11,203,236,0.18)',
                }}>
<video
    ref={videoRef}
    key={isPortrait ? 'portrait' : 'landscape'}
    src={isPortrait ? '/videos/Portrait.mp4' : '/videos/Landscape.mp4'}
    loop
    playsInline
    onPlay={() => setIsPlaying(true)}
    onPause={() => setIsPlaying(false)}
    style={{ width: '100%', height: 'auto', display: 'block' }}
/>

                    {/* Overlay — shown when paused, hidden when playing */}
                    <div
                        onClick={() => isPlaying ? videoRef.current.pause() : videoRef.current.play()}
                        style={{
                            position: 'absolute',
                            inset: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            background: isPlaying ? 'transparent' : 'rgba(0,0,0,0.35)',
                        }}
                    >
                        {!isPlaying && (
                            <div style={{
                                width: '80px',
                                height: '80px',
                                borderRadius: '50%',
                                background: 'rgba(11,203,236,0.15)',
                                backdropFilter: 'blur(8px)',
                                border: '1px solid rgba(11,203,236,0.4)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <div style={{
                                    width: 0,
                                    height: 0,
                                    borderTop: '12px solid transparent',
                                    borderBottom: '12px solid transparent',
                                    borderLeft: '22px solid #fff',
                                    marginLeft: '5px',
                                }} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

{/* ── 4.5. Quick Guide Download ────────────────────────────────────── */}
<section style={{ paddingBottom: '96px' }}>
    <div className="container">
        <div className="row justify-content-center">
            <div className="col-12" style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '24px'
            }}>
                <h2 style={{ ...S.heading, margin: 0, display: 'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center' }}>
                    Understand how it works in 
                    <span style={{ ...S.accent, marginLeft: '16px' }}>60 seconds</span>
                </h2>
                <button
    className="btn-demo-primary"
    onClick={() => { setIsDownloadModalOpen(true); setDownloadSubmitted(false); setDownloadForm({ name: '', email: '' }); }}
>
    Download Quick Guide
</button>
            </div>
        </div>
    </div>
</section>

            {/* ── 5. How It Works ──────────────────────────────────────────────── */}
            <section style={S.section} id="how-it-works">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center" style={{ marginBottom: '64px' }}>
                            <h2 style={S.heading}>How It <span style={S.accent}>Works</span></h2>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        {howItWorksSteps.map((item, index) => (
                            <div className="col-6 col-md" key={index} style={{ textAlign: 'center', padding: '0 12px', marginBottom: '24px' }}>
                                {/* Icon box */}
                                <div style={{ width: '64px', height: '64px', borderRadius: '16px', background: 'rgba(11,203,236,0.1)', border: '1px solid rgba(11,203,236,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0bcbec', margin: '0 auto 16px' }}>
                                    {item.icon}
                                </div>
                                <p style={{ fontSize: '11px', color: '#0bcbec', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '6px' }}>{item.step}</p>
                                <h6 style={{ fontSize: '15px', fontWeight: 600, color: '#fff', marginBottom: '8px' }}>{item.title}</h6>
                                <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.45)', margin: 0, lineHeight: 1.55 }}>{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── 6. Powerful Features ─────────────────────────────────────────── */}
            <section style={S.section} id="features">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center" style={{ marginBottom: '56px' }}>
                            <h2 style={S.heading}>Powerful <span style={S.accent}>Features</span></h2>
                            <p style={S.subtext}>Everything you need to transform your networking experience.</p>
                        </div>
                    </div>
                    <div className="row">
                        {features.map((item, index) => (
                            <div className="col-12 col-md-6 col-lg-4" key={index} style={{ marginBottom: '24px', display: 'flex' }}>
                                <div style={{ ...S.card, padding: '32px 28px', width: '100%', transition: 'border-color 0.2s' }}>
                                    <div style={{ ...S.iconBox }}>
                                        {item.icon}
                                    </div>
                                    <h5 style={{ fontSize: '17px', fontWeight: 600, color: '#fff', marginBottom: '10px' }}>{item.title}</h5>
                                    <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.5)', margin: 0, lineHeight: 1.65 }}>{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── 7. Dashboard ─────────────────────────────────────────────────── */}
            <section style={S.section}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center" style={{ marginBottom: '48px' }}>
                            <h2 style={S.heading}>Control Everything From <span style={S.accent}>One Dashboard</span></h2>
                            <p style={S.subtext}>A powerful analytics dashboard that gives you complete visibility and control over your AI business card performance.</p>
                        </div>
                    </div>
                    <div className="row justify-content-center" style={{ marginBottom: '48px' }}>
                        <div className="col-12">
                            <style>
                                {`
                                    .responsive-dashboard-img {
                                        width: 100%;
                                    }
                                    @media (min-width: 768px) {
                                        .responsive-dashboard-img {
                                            width: 65%;
                                        }
                                    }
                                `}
                            </style>
                            <img
                                src={dashboardImg}
                                alt="Analytics dashboard"
                                className="responsive-dashboard-img"
                                style={{ borderRadius: '16px', border: '1px solid rgba(11,203,236,0.25)', boxShadow: '0 0 48px rgba(11,203,236,0.18)', display: 'block', margin: '0 auto' }}
                            />
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        {dashboardStats.map((stat, index) => (
                            <div className="col-6 col-md-3" key={index} style={{ textAlign: 'center', marginBottom: '24px', padding: '0 12px' }}>
                                <div style={{ ...S.card, padding: '24px 16px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                                    <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'rgba(11,203,236,0.1)', border: '1px solid rgba(11,203,236,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0bcbec" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/>
                                        </svg>
                                    </div>
                                    <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.55)', margin: 0, lineHeight: 1.4 }}>{stat.label}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── 8. Use Cases ─────────────────────────────────────────────────── */}
            <section style={S.section} id="use-cases">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center" style={{ marginBottom: '56px' }}>
                            <h2 style={S.heading}>Built for <span style={S.accent}>Every Industry</span></h2>
                            <p style={S.subtext}>See how different industries are transforming their networking.</p>
                        </div>
                    </div>
                    <div className="row">
                        {useCases.map((item, index) => (
                            <div className="col-12 col-md-6 col-lg-3" key={index} style={{ marginBottom: '24px', display: 'flex' }}>
                                <div style={{ ...S.card, borderRadius: '16px', overflow: 'hidden', padding: 0, width: '100%' }}>
                                    <img
                                        src={item.img}
                                        alt={item.title}
                                        style={{ width: '100%', height: '192px', objectFit: 'cover', display: 'block' }}
                                    />
                                    <div style={{ padding: '20px 20px 24px' }}>
                                        <h5 style={{ fontSize: '16px', fontWeight: 600, color: '#fff', marginBottom: '8px' }}>{item.title}</h5>
                                        <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', margin: 0, lineHeight: 1.6 }}>{item.desc}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── 9. Comparison Table ──────────────────────────────────────────── */}
            <section style={S.section}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center" style={{ marginBottom: '56px' }}>
                            <h2 style={S.heading}>Traditional vs <span style={S.accent}>AI AR Card</span></h2>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-10 col-lg-8">
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                                            <th style={{ textAlign: 'left', padding: '16px', fontSize: '13px', color: 'rgba(255,255,255,0.4)', fontWeight: 600 }}>Feature</th>
                                            <th style={{ textAlign: 'center', padding: '16px', fontSize: '13px', color: 'rgba(255,255,255,0.4)', fontWeight: 600 }}>Traditional Digital Card</th>
                                            <th style={{ textAlign: 'center', padding: '16px', fontSize: '13px', color: '#0bcbec', fontWeight: 600 }}>AI AR Business Card</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {comparisonRows.map((row, index) => (
                                            <tr key={index} style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                                                <td style={{ padding: '14px 16px', fontSize: '14px', color: 'rgba(255,255,255,0.8)' }}>{row.feature}</td>
                                                <td style={{ padding: '14px 16px', textAlign: 'center' }}>{row.traditional ? <CheckIcon /> : <XIcon />}</td>
                                                <td style={{ padding: '14px 16px', textAlign: 'center' }}>{row.aiAr ? <CheckIcon /> : <XIcon />}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── 10. Quote Form ───────────────────────────────────────────────── */}
            <section id="quote-form" style={S.section}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center" style={{ marginBottom: '40px' }}>
                            <h2 style={S.heading}>Answer a Few Questions. <span style={S.accent}>Get Your Card Estimate.</span></h2>
                            <p style={S.subtext}>
                                Configure your AI AR business card package and get an instant pricing estimate.
                            </p>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10">
                            <div style={{ ...S.glowCard, padding: '32px', maxWidth: '920px', margin: '0 auto' }}>
                                <div style={{ textAlign: 'left', marginBottom: '22px' }}>
                                    <h3 style={{ color: '#fff', fontSize: '24px', marginBottom: '8px' }}>Get Your AI AR Business Card Quote</h3>
                                    <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: '14px', lineHeight: 1.7, marginBottom: 0 }}>
                                        Answer a few quick questions and we will generate your estimated first-year quote instantly.
                                    </p>
                                </div>

                                <div className="row">
                                    <div className="col-12 col-md-6" style={{ marginBottom: '22px' }}>
                                        <label style={{ fontWeight: 600, display: 'block', marginBottom: '8px', color: '#fff', fontSize: '15px' }}>1. Number of Unique AI AR Business Cards?</label>
                                        <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', marginBottom: '8px', display: 'block' }}>Each person gets their own AI avatar, voice, and analytics. Most small teams start with 3-5 cards.</span>
                                        <input type="number" min="1" value={quoteForm.numCards} onChange={(e) => setQuoteForm((f) => ({ ...f, numCards: e.target.value }))} style={{ width: '100%', padding: '13px 14px', background: 'rgba(0,0,0,0.18)', border: '1px solid rgba(255,255,255,0.12)', color: '#fff', borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }} />
                                    </div>

                                    <div className="col-12 col-md-6" style={{ marginBottom: '22px' }}>
                                        <label style={{ fontWeight: 600, display: 'block', marginBottom: '8px', color: '#fff', fontSize: '15px' }}>2. What best describes your use case?</label>
                                        <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', marginBottom: '8px', display: 'block' }}>This helps us tailor recommendations for your industry.</span>
                                        <select value={quoteForm.industryType} onChange={(e) => setQuoteForm((f) => ({ ...f, industryType: e.target.value }))} style={{ width: '100%', padding: '13px 14px', background: 'rgba(0,0,0,0.18)', border: '1px solid rgba(255,255,255,0.12)', color: '#fff', borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}>
                                            <option value="sales">Corporate sales / reps</option>
                                            <option value="real-estate">Real estate & property</option>
                                            <option value="events">Events & exhibitions</option>
                                            <option value="luxury">Luxury brands</option>
                                            <option value="other">Other / not listed</option>
                                        </select>
                                    </div>

                                    <div className="col-12 col-md-6" style={{ marginBottom: '22px' }}>
                                        <label style={{ fontWeight: 600, display: 'block', marginBottom: '8px', color: '#fff', fontSize: '15px' }}>3. Choose your avatar style</label>
                                        <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', marginBottom: '8px', display: 'block' }}>Use a ready-made professional avatar, or create a 1:1 photorealistic digital twin of you.</span>
                                        <select value={quoteForm.avatarType} onChange={(e) => setQuoteForm((f) => ({ ...f, avatarType: e.target.value }))} style={{ width: '100%', padding: '13px 14px', background: 'rgba(0,0,0,0.18)', border: '1px solid rgba(255,255,255,0.12)', color: '#fff', borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}>
                                            <option value="standard">Standard professional avatar (included)</option>
                                            <option value="custom">Photorealistic digital twin (+$1,600 per card, one-time)</option>
                                        </select>
                                    </div>

                                    <div className="col-12 col-md-6" style={{ marginBottom: '22px' }}>
                                        <label style={{ fontWeight: 600, display: 'block', marginBottom: '8px', color: '#fff', fontSize: '15px' }}>4. Choose your voice</label>
                                        <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', marginBottom: '8px', display: 'block' }}>Use an ultra-realistic AI voice or clone your own for maximum authenticity.</span>
                                        <select value={quoteForm.voiceType} onChange={(e) => setQuoteForm((f) => ({ ...f, voiceType: e.target.value }))} style={{ width: '100%', padding: '13px 14px', background: 'rgba(0,0,0,0.18)', border: '1px solid rgba(255,255,255,0.12)', color: '#fff', borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}>
                                            <option value="standard">Standard AI voice (included)</option>
                                            <option value="cloned">Custom voice clone (+$750 per card, one-time)</option>
                                        </select>
                                    </div>

                                    <div className="col-12 col-md-6" style={{ marginBottom: '22px' }}>
                                        <label style={{ fontWeight: 600, display: 'block', marginBottom: '8px', color: '#fff', fontSize: '15px' }}>5. What should your AI card help people do?</label>
                                        <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', marginBottom: '8px', display: 'block' }}>Choose the key actions your AI avatar should handle after it introduces you.</span>
                                        <select value={quoteForm.workflowType} onChange={(e) => setQuoteForm((f) => ({ ...f, workflowType: e.target.value }))} style={{ width: '100%', padding: '13px 14px', background: 'rgba(0,0,0,0.18)', border: '1px solid rgba(255,255,255,0.12)', color: '#fff', borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}>
                                            <option value="no">Only answer questions</option>
                                            <option value="yes">Answer questions + perform actions (from $750 per card, one-time)</option>
                                        </select>
                                    </div>

                                    <div className="col-12 col-md-6" style={{ marginBottom: '22px' }}>
                                        <label style={{ fontWeight: 600, display: 'block', marginBottom: '8px', color: '#fff', fontSize: '15px' }}>6. Expected AI conversation time per month</label>
                                        <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', marginBottom: '8px', display: 'block' }}>How many minutes per month do you expect your avatar to talk with leads and clients?</span>
                                        <select value={quoteForm.usageTier} onChange={(e) => setQuoteForm((f) => ({ ...f, usageTier: e.target.value }))} style={{ width: '100%', padding: '13px 14px', background: 'rgba(0,0,0,0.18)', border: '1px solid rgba(255,255,255,0.12)', color: '#fff', borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}>
                                            <option value="26.40">Starter - up to 250 minutes/month per card</option>
                                            <option value="118.80">Growth - up to 1,100 minutes/month per card</option>
                                            <option value="396.00">Pro - up to 3,600 minutes/month per card</option>
                                            <option value="1584.00">Enterprise - up to 13,750 minutes/month per card</option>
                                        </select>
                                    </div>

                                    <div className="col-12 col-md-6" style={{ marginBottom: '22px' }}>
                                        <label style={{ fontWeight: 600, display: 'block', marginBottom: '8px', color: '#fff', fontSize: '15px' }}>7. AI Knowledge Base Engine</label>
                                        <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', marginBottom: '8px', display: 'block' }}>Managed by AVR Labs or self-managed with your own API key.</span>
                                        <select value={quoteForm.llmType} onChange={(e) => setQuoteForm((f) => ({ ...f, llmType: e.target.value }))} style={{ width: '100%', padding: '13px 14px', background: 'rgba(0,0,0,0.18)', border: '1px solid rgba(255,255,255,0.12)', color: '#fff', borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}>
                                            <option value="0.4">Fully managed by AVR Labs (recommended)</option>
                                            <option value="0">Self-managed (I'll use my own API key)</option>
                                        </select>
                                    </div>
                                </div>

                                {quoteForm.workflowType === 'yes' && (
                                    <div style={{ marginBottom: '24px' }}>
                                        <label style={{ fontWeight: 600, display: 'block', marginBottom: '8px', color: '#fff', fontSize: '15px' }}>If yes, what actions do you want?</label>
                                        <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', marginBottom: '8px', display: 'block' }}>Example: capture name and email, open WhatsApp chat, show portfolio link, book a meeting.</span>
                                        <textarea value={quoteForm.workflowDesc} onChange={(e) => setQuoteForm((f) => ({ ...f, workflowDesc: e.target.value }))} placeholder="Tell us what you'd like your AI card to do after the conversation." style={{ width: '100%', padding: '13px 14px', background: 'rgba(0,0,0,0.18)', border: '1px solid rgba(255,255,255,0.12)', color: '#fff', borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box', resize: 'vertical', minHeight: '90px' }} />
                                    </div>
                                )}

                                <div style={{ ...S.card, padding: '24px', borderRadius: '14px', border: '1px solid rgba(11,203,236,0.28)', marginTop: '8px' }}>
                                    <h3 style={{ color: '#fff', marginTop: 0, marginBottom: '14px', fontSize: '18px' }}>Where should we send your detailed quote?</h3>
                                    <form
                                        onSubmit={async (e) => {
                                            e.preventDefault();
                                            const emailValue = quoteForm.clientEmail.trim();
                                            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                            if (!emailRegex.test(emailValue)) {
                                                setQuoteEmailError('Please enter a valid work email address');
                                                return;
                                            }
                                            setQuoteEmailError('');
                                            const escapeHtml = (value) => {
                                                const str = value === null || value === undefined ? '' : String(value);
                                                return str
                                                    .replace(/&/g, '&amp;')
                                                    .replace(/</g, '&lt;')
                                                    .replace(/>/g, '&gt;')
                                                    .replace(/"/g, '&quot;')
                                                    .replace(/'/g, '&#039;');
                                            };

                                            const workflowDetailsEscaped = escapeHtml(quoteForm.workflowDesc || 'N/A').replace(/\n/g, '<br/>');
                                            const payload = {
                                                firstName: quoteForm.clientName,
                                                lastName: quoteForm.clientCompany,
                                                email: emailValue,
                                                industry: 'AI AR Business Card Quote',
                                                phone: 'N/A',
                                                message: `
                                                    <strong>Company:</strong> ${escapeHtml(quoteForm.clientCompany)}<br/>
                                                    <strong>Number of cards:</strong> ${escapeHtml(quoteForm.numCards)}<br/>
                                                    <strong>Use case:</strong> ${escapeHtml(quoteForm.industryType)}<br/>
                                                    <strong>Avatar type:</strong> ${escapeHtml(quoteForm.avatarType)}<br/>
                                                    <strong>Voice type:</strong> ${escapeHtml(quoteForm.voiceType)}<br/>
                                                    <strong>Workflow type:</strong> ${escapeHtml(quoteForm.workflowType)}<br/>
                                                    <strong>Workflow details:</strong> ${workflowDetailsEscaped}<br/>
                                                    <strong>Usage tier:</strong> ${escapeHtml(quoteForm.usageTier)}<br/>
                                                    <strong>LLM type:</strong> ${escapeHtml(quoteForm.llmType)}<br/>
                                                    <strong>Estimated quote:</strong> USD ${escapeHtml(quoteTotal.usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))} | AED ${escapeHtml(quoteTotal.aed.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}<br/>
                                                `,
                                            };
                                            setQuoteModalTotal({ usd: quoteTotal.usd, aed: quoteTotal.aed });
                                            setQuoteResultVisible(true);
                                            setQuoteSubmitLoading(true);
                                            console.log('Lead Captured:', {
                                                name: quoteForm.clientName,
                                                email: quoteForm.clientEmail,
                                                company: quoteForm.clientCompany,
                                                workflowAction: quoteForm.workflowType,
                                                workflowDesc: quoteForm.workflowDesc,
                                                quoteUSD: quoteTotal.usd,
                                            });
                                            setQuoteForm({
                                                numCards: 1,
                                                industryType: 'sales',
                                                avatarType: 'standard',
                                                voiceType: 'standard',
                                                workflowType: 'no',
                                                workflowDesc: '',
                                                usageTier: 26.4,
                                                llmType: 0.4,
                                                clientName: '',
                                                clientCompany: '',
                                                clientEmail: '',
                                            });

                                            try {
                                                const contactFormHandlerUrl = getContactFormHandlerUrl();
                                                await fetch(contactFormHandlerUrl, {
                                                    method: 'POST',
                                                    headers: { 'Content-Type': 'application/json' },
                                                    body: JSON.stringify(payload),
                                                });
                                            } catch (error) {
                                                // Non-blocking for UX: quote result is already shown.
                                                console.error('Quote form submission failed:', error);
                                            } finally {
                                                setQuoteSubmitLoading(false);
                                            }
                                        }}
                                    >
                                        <div className="row">
                                            <div className="col-12 col-md-4" style={{ marginBottom: '10px' }}>
                                                <input required type="text" placeholder="Full name" value={quoteForm.clientName} onChange={(e) => setQuoteForm((f) => ({ ...f, clientName: e.target.value }))} style={{ width: '100%', padding: '13px 14px', background: 'rgba(0,0,0,0.18)', border: '1px solid rgba(255,255,255,0.12)', color: '#fff', borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }} />
                                            </div>
                                            <div className="col-12 col-md-4" style={{ marginBottom: '10px' }}>
                                                <input required type="text" placeholder="Company name" value={quoteForm.clientCompany} onChange={(e) => setQuoteForm((f) => ({ ...f, clientCompany: e.target.value }))} style={{ width: '100%', padding: '13px 14px', background: 'rgba(0,0,0,0.18)', border: '1px solid rgba(255,255,255,0.12)', color: '#fff', borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }} />
                                            </div>
                                            <div className="col-12 col-md-4" style={{ marginBottom: '10px' }}>
                                                <input required type="email" placeholder="Work email address" value={quoteForm.clientEmail} onChange={(e) => { setQuoteForm((f) => ({ ...f, clientEmail: e.target.value })); if (quoteEmailError) setQuoteEmailError(''); }} style={{ width: '100%', padding: '13px 14px', background: 'rgba(0,0,0,0.18)', border: quoteEmailError ? '1px solid #e05c5c' : '1px solid rgba(255,255,255,0.12)', color: '#fff', borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }} />
                                            </div>
                                        </div>
                                        {quoteEmailError && (
                                            <div style={{ color: '#e07575', fontSize: '12px', marginTop: '-2px', marginBottom: '8px' }}>
                                                {quoteEmailError}
                                            </div>
                                        )}
                                        <button type="submit" disabled={quoteSubmitLoading} className="btn-demo-primary" style={{ marginTop: '8px', width: '100%', opacity: quoteSubmitLoading ? 0.7 : 1, cursor: quoteSubmitLoading ? 'not-allowed' : 'pointer' }}>
                                            {quoteSubmitLoading ? 'Sending...' : 'Email me my custom quote'}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── 11. FAQ ──────────────────────────────────────────────────────── */}
            <section style={S.section} id="faq">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center" style={{ marginBottom: '56px' }}>
                            <h2 style={S.heading}>Frequently Asked <span style={S.accent}>Questions</span></h2>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8">
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                {faqItems.map((item, index) => (
                                    <div key={index} style={{ ...S.card, borderRadius: '16px', overflow: 'hidden' }}>
                                        <button
                                            onClick={() => setOpenFaq(openFaq === index ? null : index)}
                                            style={{ width: '100%', background: 'none', border: 'none', padding: '20px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', color: '#fff', textAlign: 'left', gap: '16px' }}
                                        >
                                            <span style={{ fontWeight: 500, fontSize: '15px' }}>{item.question}</span>
                                            <ChevronDownIcon open={openFaq === index} />
                                        </button>
                                        {openFaq === index && (
                                            <div style={{ padding: '0 24px 20px', fontSize: '14px', color: 'rgba(255,255,255,0.5)', lineHeight: 1.75 }}>
                                                {item.answer}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── 12. CTA ──────────────────────────────────────────────────────── */}
            <div className="custom-cta-wrapper">
                <style>
                    {`
                        .custom-cta-wrapper img {
                            opacity: 0.3;
                        }
                    `}
                </style>
                <Create style={{ marginTop: '40px' }} data={contactData} />
            </div>
{/* ── Download Guide Modal ─────────────────────────────────────────── */}
{isDownloadModalOpen && (
    <div
        onClick={() => setIsDownloadModalOpen(false)}
        style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(6px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '24px',
        }}
    >
        <div
            onClick={e => e.stopPropagation()}
            style={{
                background: '#0e1c3d', border: '1px solid rgba(11,203,236,0.25)',
                borderRadius: '20px', padding: '40px 36px', width: '100%', maxWidth: '420px',
                boxShadow: '0 0 60px rgba(11,203,236,0.15)', position: 'relative',
            }}
        >
            <button
                onClick={() => setIsDownloadModalOpen(false)}
                style={{
                    position: 'absolute', top: '16px', right: '16px',
                    background: 'none', border: 'none', cursor: 'pointer',
                    color: 'rgba(255,255,255,0.4)', fontSize: '22px', lineHeight: 1,
                }}
            >×</button>

            {!downloadSubmitted ? (
                <>
                    <h3 style={{ color: '#fff', fontSize: '22px', fontWeight: 700, marginBottom: '8px' }}>
                        Get the Quick Guide
                    </h3>
                    <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '14px', marginBottom: '28px' }}>
                        Enter your details and the PDF will download instantly.
                    </p>

                    {downloadError && (
                        <div style={{ padding: '10px 14px', borderRadius: '6px', fontSize: '13px', marginBottom: '16px', background: 'rgba(220,53,69,0.2)', color: '#eb5757', border: '1px solid rgba(220,53,69,0.3)' }}>
                            Something went wrong. Please try again.
                        </div>
                    )}

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <div>
                            <label style={{ display: 'block', color: 'rgba(255,255,255,0.6)', fontSize: '13px', marginBottom: '6px' }}>Name *</label>
                            <input
                                type="text"
                                placeholder="Your name"
                                value={downloadForm.name}
                                onChange={e => setDownloadForm(f => ({ ...f, name: e.target.value }))}
                                style={{
                                    width: '100%', boxSizing: 'border-box',
                                    background: '#162040', border: `1px solid ${downloadFormErrors.name ? '#e05c5c' : 'rgba(255,255,255,0.1)'}`,
                                    borderRadius: '6px', padding: '10px 14px', color: '#fff', fontSize: '14px', outline: 'none',
                                }}
                            />
                            {downloadFormErrors.name && <div style={{ color: '#e07575', fontSize: '12px', marginTop: '4px' }}>{downloadFormErrors.name}</div>}
                        </div>
                        <div>
                            <label style={{ display: 'block', color: 'rgba(255,255,255,0.6)', fontSize: '13px', marginBottom: '6px' }}>Email *</label>
                            <input
                                type="email"
                                placeholder="your@email.com"
                                value={downloadForm.email}
                                onChange={e => setDownloadForm(f => ({ ...f, email: e.target.value }))}
                                style={{
                                    width: '100%', boxSizing: 'border-box',
                                    background: '#162040', border: `1px solid ${downloadFormErrors.email ? '#e05c5c' : 'rgba(255,255,255,0.1)'}`,
                                    borderRadius: '6px', padding: '10px 14px', color: '#fff', fontSize: '14px', outline: 'none',
                                }}
                            />
                            {downloadFormErrors.email && <div style={{ color: '#e07575', fontSize: '12px', marginTop: '4px' }}>{downloadFormErrors.email}</div>}
                        </div>
                        <button
                            disabled={downloadLoading}
                            onClick={async () => {
                                // Validate
                                const errors = {};
                                if (!downloadForm.name.trim())  errors.name  = 'Name is required';
                                if (!downloadForm.email.trim()) errors.email = 'Email is required';
                                setDownloadFormErrors(errors);
                                if (Object.keys(errors).length > 0) return;

                                setDownloadLoading(true);
                                setDownloadError(false);
                                try {
                                    const contactFormHandlerUrl = getContactFormHandlerUrl();
                                    const response = await fetch(contactFormHandlerUrl, {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({
                                            firstName: downloadForm.name,
                                            lastName: '',
                                            email: downloadForm.email,
                                            industry: 'Quick Guide Download',
                                            phone: '',
                                            message: 'Requested the AR Business Card Quick Guide PDF.',
                                        }),
                                    });
                                    if (response.ok) {
                                        // Trigger download
                                        const link = document.createElement('a');
                                        link.href = '/videos/AI-Powered Digital Avatar on your Business Card.pdf';
                                        link.download = 'AI-Powered Digital Avatar on your Business Card.pdf';
                                        link.click();
                                        setDownloadSubmitted(true);
                                    } else {
                                        setDownloadError(true);
                                    }
                                } catch {
                                    setDownloadError(true);
                                } finally {
                                    setDownloadLoading(false);
                                }
                            }}
                            className="btn-demo-primary"
                            style={{
                                width: '100%', marginTop: '4px', fontSize: '15px', padding: '13px',
                                opacity: downloadLoading ? 0.6 : 1,
                                cursor: downloadLoading ? 'not-allowed' : 'pointer',
                            }}
                        >
                            {downloadLoading ? 'Submitting…' : 'Download Now'}
                        </button>
                    </div>
                </>
            ) : (
                <div style={{ textAlign: 'center', padding: '16px 0' }}>
                    <div style={{ fontSize: '40px', marginBottom: '16px' }}>✅</div>
                    <h3 style={{ color: '#fff', fontSize: '20px', fontWeight: 700, marginBottom: '8px' }}>
                        Your download has started!
                    </h3>
                    <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '14px' }}>
                        Thanks, {downloadForm.name}. Check your downloads folder.
                    </p>
                </div>
            )}
        </div>
    </div>
)}
{/* ── Quote Result Modal ───────────────────────────────────────────── */}
{quoteResultVisible && (
    <div
        onClick={() => setQuoteResultVisible(false)}
        style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: 'rgba(0,0,0,0.72)', backdropFilter: 'blur(6px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '24px',
        }}
    >
        <div
            onClick={e => e.stopPropagation()}
            style={{
                ...S.glowCard,
                width: '100%',
                maxWidth: '520px',
                padding: '32px 28px',
                borderRadius: '16px',
                textAlign: 'center',
                position: 'relative',
            }}
        >
            <button
                onClick={() => setQuoteResultVisible(false)}
                style={{
                    position: 'absolute', top: '14px', right: '14px',
                    background: 'none', border: 'none', cursor: 'pointer',
                    color: 'rgba(255,255,255,0.4)', fontSize: '22px', lineHeight: 1,
                }}
            >×</button>

            <h3 style={{ margin: '0 0 10px 0', fontSize: '16px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'rgba(255,255,255,0.7)' }}>
                Your Custom First-Year Investment
            </h3>
            <div style={{ fontSize: '38px', fontWeight: 800, marginBottom: '6px', color: '#fff' }}>
                ${quoteModalTotal.usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
            <div style={{ fontSize: '15px', fontWeight: 600, color: '#0bcbec' }}>
                AED {quoteModalTotal.aed.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
            <div style={{ fontSize: '12px', marginTop: '14px', color: 'rgba(255,255,255,0.5)', lineHeight: 1.7 }}>
                Estimate includes: one-time setup and configuration, selected avatar and voice options, action workflows (if chosen), and a 12-month interaction plan for all cards.
            </div>
            <a
                href="https://calendar.app.google/xrBgEtuWS7T2JMKt6"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-demo-primary"
                style={{ width: '100%', marginTop: '18px', display: 'inline-block', textAlign: 'center', textDecoration: 'none', boxSizing: 'border-box' }}
            >
                Book your onboarding call
            </a>
        </div>
    </div>
)}
            <ContactModal 
                isOpen={isDemoModalOpen} 
                onClose={() => setIsDemoModalOpen(false)} 
            />
            <Footer />
        </div>
    );
}

export default BusinessCard;